import { logger } from '@sendpayments/js-utils';
import { get } from 'lodash';
import { buildPartiallyUpdated } from '@sendpayments/js-utils/dist/services/partial-updates';
import { reduce as updateEntityReducer } from './update-entity';

export const reduce = (state, action) => {
  if (!get(action, 'payload.entity.id')) {
    logger.error(
      '@sendpayments/react-shared/remote-data',
      `reducer/PARTIAL_UPDATE_ENTITY. payload.entity.id must be present for a partial update`,
      action,
    );
    return state;
  }

  const payload = {
    entity: buildPartiallyUpdated(action.payload.entity),
  };

  return updateEntityReducer(state, { payload });
};
